import { render, staticRenderFns } from "./SousTotalRow.vue?vue&type=template&id=2fc5add3"
import script from "./SousTotalRow.vue?vue&type=script&lang=js"
export * from "./SousTotalRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports